import React from "react";
import blog_card from "../../../assets/img/blog_card.svg";
import blog_details from "../../../assets/img/blog_details.svg";
import { getBlogDetailListData } from "../../../Redux/Common/BlogDetailSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import Loader from "../../Loader/Loader"; // adjust the path

import moment from "moment";
import { Col, Row } from "react-bootstrap";
import { set } from "date-fns";
import { useGlobalState } from "../../../Providers/GlobalStateProvider";

const BlogDetail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { setGlobalLoading } = useGlobalState();

  const [blogDetail, setBlogDetail] = useState(null);
  const [otherBlogs, setOtherBlogs] = useState([]);
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const pathParts = window.location.pathname.split("/");
    const blogId = pathParts[pathParts.length - 1];
    dispatch(getBlogDetailListData({ blogId: blogId }));
  }, [dispatch, window.location.pathname]);

  const blogDetailResponse = useSelector(
    (state) => state.getBlogDetailReducer.data
  );

  useEffect(() => {
    //console.log("blogDetailResponse.data.test ===>", blogDetailResponse);
    if (blogDetailResponse != null && blogDetailResponse.status === true) {
      setLoading(false);
      setGlobalLoading(false);
      setBlogDetail(blogDetailResponse.data);
      setOtherBlogs(blogDetailResponse.otherBlogs || []);
      setTags(blogDetailResponse.data.tags.split(",") || []);
    } else if (blogDetailResponse != null) {
      setLoading(false);
      setGlobalLoading(false);
      console.error("Error fetching home data:", blogDetailResponse.message);
    }
  }, [blogDetailResponse]);

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

   if (loading) {
    setGlobalLoading(true);
    return <div style={{ height: "100vh" }}><Loader /></div>;
  }

  return (
    blogDetail && (
      <div className="blog-detail pb-4 pb-md-5">
        {/* Hero Image */}
        <div className="custom_container">
          <div className="blog-detail__hero">
            <img src={blogDetail.image} alt={blogDetail.title} />
          </div>
        </div>

        {/* Breadcrumb */}
        <div className="custom_container pt-4 pt-sm-5">
          {/* <nav className="breadcrumb">
            <a href="/" onClick={() => handleViewDetails()}>
              HOME
            </a>
            <span className="separator">/</span>
            <a href="/blogs">DIRECTORY</a>
            <span className="separator">/</span>
            <span className="current">BLOG</span>
          </nav> */}
          <nav className="breadcrumb">
            {tags.map((tag, index) => (
              <span key={index} className="separator">
                {tag}
              </span>
            ))}
            {/* <span className="separator">Painting</span>
            <span className="separator">Color Theory</span>
            <span className="separator">Guide</span> */}
          </nav>
          {/* Blog Header */}
          <div className="blog-detail__header">
            <h1 className="blog-detail__title">{blogDetail.title}</h1>
            <div className="blog-detail__meta">
              <div className="date">
                {blogDetail.author} <div className="mx-3">•</div>
                {moment(blogDetail.createdAt).format("MM/DD/YYYY")}
              </div>
            </div>
          </div>
          {/* Blog Content */}
          <div className="blog-detail__content">
            <div key="section" className="content-section">
              <p dangerouslySetInnerHTML={{ __html: blogDetail.content }}></p>
            </div>
          </div>
         
          <div className="related-articles">
            <h2 className="related-articles__title">Related Articles</h2>

            <Row>
              {otherBlogs != null &&
                otherBlogs.map((item) => (
                  <Col sm={12} lg={6} xl={4} className="mt-3" key={item._id}>
                    <div className="related-articles__grid">
                      <div className="related-card">
                        <div className="related-card__image">
                          <img src={item.image} alt={item.title} />
                        </div>
                        <div className="related-card__content">
                          <div className="related-card__tags">
                            {item.tags &&
                              item.tags.split(",").map((tag, index) => (
                                <span key={index} className="tag">
                                  {tag.trim()}
                                </span>
                              ))}
                          </div>
                          <h3 className="related-card__title">{item.title}</h3>
                          <p
                            className="related-card__excerpt"
                            dangerouslySetInnerHTML={{ __html: item.content }}
                          ></p>
                          <button
                            className="btn-read-more"
                            onClick={() => {
                              handleViewDetails();
                              navigate(`/blog-detail/${item._id}`);
                            }}
                          >
                            Read more
                          </button>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
            </Row>
          </div>
        </div>
      </div>
    ));
};

export default BlogDetail;
